import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import ClientContext from "./ClientContext.js";
import StatusContext from './StatusContext.js';
import axios from "axios"
/*
import { languagesamples } from "../data/LanguageSamples.ts"
import { assistantsamples } from "../data/AssistantSamples.ts"
import { assistantsamples_Serbian } from "../data/AssistantSamples_Serbian.ts"
import { assistantsamples_Spanish } from "../data/AssistantSamples_Spanish.ts"
import { assistantsamples_Portuguese } from "../data/AssistantSamples_Portuguese.ts"
import { assistantsamples_French } from "../data/AssistantSamples_French.ts"
import { assistantsamples_German } from "../data/AssistantSamples_German.ts"
import { businesssamples } from "../data/BusinessSamples.ts"
import { businesssamples_Serbian } from "../data/BusinessSamples_Serbian.ts"
import { businesssamples_Spanish } from "../data/BusinessSamples_Spanish.ts"
import { businesssamples_Portuguese } from "../data/BusinessSamples_Portuguese.ts"
import { businesssamples_French } from "../data/BusinessSamples_French.ts"
import { businesssamples_German } from "../data/BusinessSamples_German.ts"
import { interviewsamples } from "../data/InterviewSamples.ts"
*/
import { config } from '../config.js';
import { sortChats } from './StatusContext.js';
import { marked } from 'marked';


const ChatContext = createContext();

export default ChatContext;

var topic = '';
var topicSummary = ''
var topicSummaryIndex = 0
  
export const CopilotProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [prevpromptsandresponses, setPrevPromptsAndResponses] = useState([]);
    const[chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [prevconfirmDelete, setPrevConfirmDelete] = useState([])
    const [status, setStatus] = useState();
    const [displayrelated, setDisplayRelated] = useState(true)
    const [showCopilotProgressDialog, setShowCopilotProgressDialog] = useState(false)

   
    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
        setIsLoading,
        isLoading,
        //mainLanguage,
        changeLanguage,
        setShowLoginDialog,

        handleFocus,
        setWaitOnResponse,
        getAIProvider,
        getAIName,
        getAIModel,
        
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);


     const getTextSummary = async (text) => {

        let summary = ''
        let request = changeLanguage('assistant', 'summarizetext');
       
        let rqst = ''

        if (text.charAt[0] !== '"')
            rqst = '"' + text
        if (text.charAt[text.length-1] !== '"')
            rqst = rqst + '"'

        request = request + rqst;

        let req = {
            user: currentUser,
            request: request,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
        
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })

            let server_response = JSON.parse(res.data);

            summary = server_response.data

            updateCredits(server_response.tokens)
    
        } catch(err)
        {
            setStatus(`Error: ${checkServerCode(err.response.data)}`)

        }

        return summary
    }

    const isPromptandResponses = () => {
        return promptsandresponses.length;
    }

    const onClearChat = () => {
        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')

        topic='';
        topicSummary=''
        topicSummaryIndex = 0
    }   

    const deleteChat = async (deletionChat) => {

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/copilot/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Chats:", adjustedChats)
              
        var templates = JSON.stringify( adjustedChats)
       
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/copilot/update", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }

        setChatNames(adjustedChats);
        
        setIsLoading(false)    
    }

    const displayChat = (displayedChat) => {

        onClearChat();

        //fix prompts ids to match array indexes
        let index = 0;
        displayedChat.promptsandresponses.forEach((item) => {
                item.id = index;
                index++   
        })   
       
        setPromptsAndResponses(displayedChat.promptsandresponses)
        setPrevPromptsAndResponses([])
        setChatName(displayedChat.chatname)

        //backward compatibility
        displayedChat.summary ? topicSummary = displayedChat.summary : topicSummary=''
        console.log("topicSummary:", topicSummary)
        displayedChat.summaryindex ? topicSummaryIndex = displayedChat.summaryindex : topicSummaryIndex = 0
        console.log("topicSummaryIndex:", topicSummaryIndex)


        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
             let a = {
                id: item.id,
                state: false
             }
             deletes.push(a)   
        })

        setConfirmDelete(deletes)
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        let index = promptsandresponses.indexOf(deletionChat)
        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        
        if (index > 0 && topicSummaryIndex)
            topicSummaryIndex -= 1
        
        setPromptsAndResponses(filteredChats)
        
        let deleteconfirm = [...confirmDelete]
        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item)=>{
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)

    }
    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        setIsLoading(true)

        let q = "/deda_ai_api/copilot/get"

        const res = await axios.post(config.url.API_URL + q, {currentUser}) 
          
        if (res.data.length > 0 )
        {
            //user exists, so update chats
            let newchatNames = [...chatNames];
            let newChat = {}
            let exists = false

            for (let i = 0; i < newchatNames.length; ++i)
            {
                if (newchatNames[i].chatname === chatName)
                    {
                        let result = window.confirm( changeLanguage('tutor', 'sametopic') );
                        if (!result)
                        {
                            setIsLoading(false)
                            return;
                        }

                        newchatNames[i].promptsandresponses = promptsandresponses
                        exists = true
                        let templates = JSON.stringify(newchatNames)
                        //console.log("Update copilot:", templates)
                                                
                        try{
                             await axios.post(config.url.API_URL + "/deda_ai_api/copilot/update", {currentUser, templates},{
                                     withCredentials:true
                            })
                        }
                        catch (err) {
                            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
                            setIsLoading(false);
                            return
                        }
                        //Update complete
                        setIsLoading(false)         
                        return

                    }
            }

            if (exists)
            {
                //Update existing chat
                let templates = JSON.stringify(newchatNames)
                console.log("Update copilot:", templates)
                                        
                try{
                     await axios.post(config.url.API_URL + "/deda_ai_api/copilot/update", {currentUser, templates},{
                             withCredentials:true
                    })
                }
                catch (err) {
                    setStatus(`Error: ${checkServerCode(err.code)}`)
                    setIsLoading(false);
                    return;
                }
                //Update complete
                setIsLoading(false)         
                return
            }
            else
            {
                //add new chat
                newChat = {
                    chatname: chatName,
                     summary: topicSummary,
                     summaryindex: topicSummaryIndex,
                    promptsandresponses: promptsandresponses 
                }

                newchatNames.push(newChat)
                let adjustedChats = sortChats(newchatNames)

                //Update existing chat
                let templates = JSON.stringify(adjustedChats)
                console.log("Update copilot:", templates)
                                        
                try{
                     await axios.post(config.url.API_URL + "/deda_ai_api/copilot/update", {currentUser, templates},{
                             withCredentials:true
                    })
                }
                catch (err) {
                    setStatus(`Error: ${checkServerCode(err.code)}`)
                    setIsLoading(false);
                    return;
                }
                //Update complete
                setChatNames(adjustedChats)
                setIsLoading(false)         
                return

            }
        }
        else // res.data.length === 0
        {
            let newChat = {
                chatname: chatName,
                promptsandresponses: promptsandresponses 
            }
            let newchatNames = []

            newchatNames.push(newChat)
            let adjustedChats = sortChats(newchatNames)

            //Update existing chat
            let templates = JSON.stringify(adjustedChats)
           
            console.log("Update copilot:", templates)
                                    
            try{
                 await axios.post(config.url.API_URL + "/deda_ai_api/copilot/save", {currentUser, templates},{
                         withCredentials:true
                })
            }
            catch (err) {
                console.log("Update err:", err)
                setStatus(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false);
                return
            }
            //Update complete
            setChatNames(newchatNames)
            setIsLoading(false)         
            return

        }       

}

    /*
    const onSave = async () => {
        

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let exists = false;
    
        let newChats = [];
        let newChat=[];
        let newchatNames = [];


        setIsLoading(true);

        let chatstatus = await getChats('chats');
       
        if (chatstatus.status !== 200)
        {
            setStatus("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm("There is already saved conversation with this name. Do you want to overwrite it?");
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }

                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0;

            newchatNames === 0 ? i = 1 : i = newchatNames.length;
       
            newChat = {
                id: i,
                chatname: chatName,
                topic: topic,
                promptsandresponses: promptsandresponses,
            };

            newChats.push(newChat);
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }
            
        let templates = JSON.stringify( newChats)
       
        
        try{
           await axios.post(config.url.API_URL + "/deda_ai_api/chats/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false);
            return err;
        }
       
        setChatNames(newChats)
        setIsLoading(false);
        
    }
    */

    const onSubmitChat = () => {
        if (checkCurrentUser() === false)
        {
            //setStatus(changeLanguage('status', 'pleaselogin'))
            setShowLoginDialog(true)
            return;
        }

        SendRequest(chatPrompt)
        
    }

    const onResubmitChat = (prompt) => {
    
        SendRequest(prompt.prompt)
        
    }

    function markdownToPlainText(markdown) {
        // Use marked to convert Markdown to HTML
        const html = marked(markdown);
        
        // Create a temporary DOM element to strip out HTML tags
        const temporaryElement = document.createElement('div');
        temporaryElement.innerHTML = html;
        
        // Return the plain text content
        return temporaryElement.innerText || temporaryElement.textContent;
    }

    const onSubmitQuestion = (question) => {
       
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let a = markdownToPlainText(question)

        SendRequest(a)

    }

    const onClickRelated = () => {
        setDisplayRelated(!displayrelated)
    }

    const onReverse = () => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (prevpromptsandresponses.length)  setPromptsAndResponses(prevpromptsandresponses)
        setPrevPromptsAndResponses([])
    
        if (prevconfirmDelete.length)  setConfirmDelete(prevconfirmDelete)
        setPrevConfirmDelete([])
      
    }

  
    async function SendRequest(request) {

        let server_response = ''

        let response = ''
       
        setStatus("");
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        let i = 0;
        if (promptsandresponses.length)
        {
            i = promptsandresponses[promptsandresponses.length-1].id + 1
        }

        let r = {
            id:i,
            prompt:request,
            response:"",
            topic: "",
            question_1:"",
            question_2:"",
            question_3:"",
            question_4:"",
            question_5:"",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),

        }
       
        setPromptsAndResponses([...promptsandresponses, r]) 
        
        if (promptsandresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }
        
        if (confirmDelete.length <= promptsandresponses.length)
        {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a ]) 
        }
        setShowCopilotProgressDialog(true)
        setIsLoading(true)

        let rqst = ''

        if (topicSummary.length > 0)
        {
            topic = topicSummary
            const temparray = promptsandresponses.filter((value, index) => index > topicSummaryIndex);
            temparray.forEach((item) => {
                topic += item.response
            }) 
        }
        else {
            promptsandresponses.forEach((item) => {
                topic += item.response
            }) 
        }
         
        if (topic.length > 3000)
        {
            topicSummary = await getTextSummary(topic)
            topicSummaryIndex = promptsandresponses.length
            console.log("topicSummary:", topicSummary)
            topic = topicSummary
        }

        if (topic.length > 0)
        {
           rqst += `The context of conversation is: ${topic}.\n`
        }

        //rqst += "Tell me more about :" + request;
        rqst += "Provide and answer to the following query:" + request;
        setChatPrompt('')

        let req = {
            user: currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
   
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })

            server_response = JSON.parse(res.data);
            response = server_response.data
            //console.log("Response:", server_response)
            updateCredits(server_response.tokens)
        } catch (err) {
          
            console.log("Error:", err)
            setStatus(changeLanguage('aitest', 'somethingwentwrong'))
            setShowCopilotProgressDialog(false)
            setIsLoading(false)
            return
        }
        
          rqst = `The topic is '${server_response.data}'. Give me 5 questions related to <topic>. Provide straight questions as a markdown text in the following format:  %%@<question>@%%`
          
          req = {
              user:currentUser,
              request: rqst,
              temperature: 1,
              aiprovider: getAIProvider(),
              aimodel: getAIModel(),
              ainame: getAIName(),
          }
  
          try {
              const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                  withCredentials: true
              })
            
              let server_response = JSON.parse(res.data);
             
              //tokenise question
              //Regular expression to match the pattern ##@...@##
                const regex = /%%@(.*?)@%%/g;

                // Use match to extract all matches
                const matches = server_response.data.match(regex);

                // Check if matches were found
                let questions = []
                let p = ''
               
                if (matches) {
                    let j = 0
                    while (j < matches.length)
                    {
                        //console.log("Matches[j]:", matches[j]);
                        p = matches[j].replace(/%%@|@%%/g, '')
                        questions.push(p)
                        j++;
                    }
                } else {
                    console.log('No questions found.');
                    setStatus(changeLanguage('aitest', 'somethingwentwrong'))
                    setShowCopilotProgressDialog(false)
                    setIsLoading(false)
                    return
                }

              if (promptsandresponses.length)
                i = promptsandresponses[promptsandresponses.length-1].id + 1
              else 
                i = 0
              
                r = {
                    id: i,
                    prompt: request,
                    response: response,
                    topic: topic,
                    question_1: questions.length >= 1 ? questions[0] : null,
                    question_2: questions.length >= 2 ? questions[1] : null,
                    question_3: questions.length >= 3 ? questions[2] : null,
                    question_4: questions.length >= 4 ? questions[3] : null,
                    question_5: questions.length >= 5 ? questions[4] : null,
                    aiprovider: getAIProvider(),
                    aimodel: getAIModel(),
                    ainame: getAIName(),
                  };    
                
                setPromptsAndResponses([...promptsandresponses, r])
                setWaitOnResponse('')
                handleFocus()
                updateCredits(server_response.tokens)
          } catch (err) {
              console.log("Error:", err)
              setStatus(changeLanguage('aitest', 'somethingwentwrong'))
          }

        setShowCopilotProgressDialog(false)
        setIsLoading(false)   
    }


    return <ChatContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse, 
        promptsandresponses, 
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
        onClearChat,
        onReverse,
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt, 
        changeConfirmDelete,
        confirmDelete,

        isPromptandResponses,
       
        status,
        setStatus,
       
        onSubmitQuestion,
        onClickRelated,
        displayrelated,
        topic,
        //request,
        
        onResubmitChat,
        SendRequest,

        showCopilotProgressDialog,
        setShowCopilotProgressDialog,
    
    }}>
        {props.children}
    </ChatContext.Provider>
})

